import { Action } from 'redux';
import { ANNOUNCEMENTS_READ } from 'src/modules/announcements/actions/AnnouncementsActions';
import { AnnouncementsState } from 'src/modules/announcements/types/AnnouncementsState';

export function announcementsReadReducer(state: AnnouncementsState, action: Action): AnnouncementsState {
  if (ANNOUNCEMENTS_READ.isSuccess(action)) {
    return {
      announcements: state.announcements.map((announcement) => ({
        ...announcement,
        read: true,
      })),
    };
  }

  return state;
}
